import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import CounterSection from "../../Component/CounterSection";
import { useAuth } from "../../Store/AuthContext";
import { AboutFetchData } from "../../APIS/FetchAPIs";

export default function About() {
  const { RendomTokenfetch, webSetting } = useAuth();
  const [aboutData] = AboutFetchData(RendomTokenfetch);

  return (
    <>
      <Helmet>
        <title>{aboutData.meta_title}</title>
        <meta name="description" content={aboutData.meta_description} />
        <meta name="keywords" content={aboutData.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="About" mainpage="" />
      <section className="about-section fix section-bg section-padding">
        <div className="right-shape">
          <img src="assets/img/home-1/about/right-shape.png" alt="img" />
        </div>
        <div className="container">
          <div className="about-wrapper">
            <div className="row g-4">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                <div className="about-image">
                  {aboutData.about_image !== "" ? (
                    <img
                      src={aboutData.about_image}
                      alt={aboutData.aboutimg_alt}
                      title={aboutData.aboutimg_title}
                    />
                  ) : (
                    ""
                  )}

                  <div className="about-image-2">
                    {aboutData.about_banner !== "" ? (
                      <img
                        src={aboutData.about_banner}
                        alt={aboutData.aboutbanner_alt}
                        title={aboutData.aboutbanner_title}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="counter-box">
                    <h2>
                      <span className="count">
                        {webSetting?.happy_customers || ""}
                      </span>{" "}
                      +
                    </h2>
                    <p>Happy Customers</p>
                  </div>
                  <span className="bar-shape"></span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-content">
                  <div className="section-title mb-0">
                    <h2 className="wow fadeInUp mb-3 aboutSectiontitle">
                      {/* <i
                        className="fa fa-angle-double-left"
                        aria-hidden="true"
                      ></i> */}
                      {aboutData?.title || ""}
                      {/* <i
                        className="fa fa-angle-double-right"
                        aria-hidden="true"
                      ></i> */}
                    </h2>
                    {/* <h3 className="wow fadeInUp" data-wow-delay=".3s">
                      Where Finding a House Feels Like Home
                    </h3> */}
                  </div>
                  <p
                    className="about-text wow fadeInUp mb-2"
                    data-wow-delay=".5s"
                  >
                    {aboutData?.about_description || ""}
                  </p>
                  <div
                    className="about-list-item wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <div className="list-item">
                      <ul className="list">
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Quality real estate services
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          100% Satisfaction guarantee
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Highly professional team
                        </li>
                        <li>
                          <i className="fa-solid fa-arrow-right"></i>
                          Dealing always on time
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CounterSection />

      <section
        className="propertie-section-3 fix section-padding bg-cover pb-3"
        style={{ backgroundImage: `url('assets/img/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="propertie-wrapper-3">
            <div className="row g-4">
              <div className="col-xl-6 col-lg-6">
                <div className="content">
                  <div className="section-title mb-0">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">
                      Our Vision and Values
                    </h2>
                  </div>
                  <p className="wow fadeInUp mt-3" data-wow-delay=".5s">
                    {aboutData?.vision || ""}
                  </p>
                </div>
                <div className="content">
                  <div className="section-title mb-0">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">
                      Mission
                    </h2>
                  </div>
                  <p className="wow fadeInUp mt-3" data-wow-delay=".5s">
                    {aboutData?.mission || ""}
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="propertie-image">
                  {aboutData.missionimage !== "" ? (
                    <img src={aboutData.missionimage} alt="" />
                  ) : (
                    <img src="assets/img/home-3/about/about3.jpeg" alt="img" />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="propertie-section-3 fix section-padding bg-cover pt-0"
        style={{ backgroundImage: `url('assets/img/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="propertie-wrapper-3">
            <div className="row g-4">
              <div className="section-title mb-0">
                <h2
                  className="wow fadeInUp aboutSectiontitle"
                  data-wow-delay=".3s"
                >
                  Our Experience & Achievements
                </h2>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="propertie-image">
                  {aboutData.experienceimage !== "" ? (
                    <img src={aboutData.experienceimage} alt="" />
                  ) : (
                    <img src="assets/img/home-3/about/about2.jpg" alt="img" />
                  )}
                </div>
              </div>
              <div className="col-xl-6 col-lg-6">
                <div className="content">
                  <p className="wow fadeInUp" data-wow-delay=".5s">
                    {aboutData?.our_experience || ""}
                  </p>
                </div>
              </div>

              <div className="col-lg-8 col-sm-12 aboutFAQS">
                <div className="faq-content">
                  <h2 className="mt-3 mb-3 aboutSectiontitle">
                    What Sets Us Apart
                  </h2>
                  <div className="faq-accordion">
                    <div className="accordion" id="accordion">
                      {aboutData.title1 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".5s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq1"
                              aria-expanded="false"
                              aria-controls="faq1"
                            >
                              {aboutData?.title1 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq1"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline1 || ""}
                            </div>
                          </div>
                        </div>
                      )}

                      {aboutData.title2 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".3s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq2"
                              aria-expanded="true"
                              aria-controls="faq2"
                            >
                              {aboutData?.title2 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq2"
                            className="accordion-collapse show"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline2 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                      {aboutData.title3 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq4"
                              aria-expanded="false"
                              aria-controls="faq4"
                            >
                              {aboutData?.title3 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq4"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline3 || ""}
                            </div>
                          </div>
                        </div>
                      )}

                      {aboutData.title4 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq5"
                              aria-expanded="false"
                              aria-controls="faq5"
                            >
                              {aboutData?.title4 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq5"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline4 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                      {aboutData.title5 !== "" && (
                        <div
                          className="accordion-item mb-2 wow fadeInUp"
                          data-wow-delay=".8s"
                        >
                          <h5 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#faq6"
                              aria-expanded="false"
                              aria-controls="faq6"
                            >
                              {aboutData?.title5 || ""} :
                            </button>
                          </h5>
                          <div
                            id="faq6"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordion"
                          >
                            <div className="accordion-body">
                              {aboutData?.tagline5 || ""}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12 col-lg-12">
                <div className="content">
                  <div className="section-title mb-0">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">
                      Our Promise
                    </h2>
                  </div>
                  <p className="wow fadeInUp mt-3" data-wow-delay=".5s">
                    {aboutData?.our_promise || ""}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
